import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LeadService } from 'app/platform/lead/lead.service';
import { LoaderService } from 'app/services/loader.service';
declare var $: any;
import * as _moment from 'moment';
const moment = (_moment as any).default ? (_moment as any).default : _moment;
@Component({
  selector: "app-forty-to-hundred",
  templateUrl: "./forty-to-hundred.component.html",
  styleUrls: ["./forty-to-hundred.component.css"],
  providers: [LeadService],
})
export class FortyToHundredComponent implements OnInit {
  // @Output() projectEvent = new EventEmitter<string>();
  // @Output() cdeevent = new EventEmitter<{ name1: number, name2: number }>();
  items: any;
  allowed_items = "40_100";
  current_page: any = 1;
  per_page: any = 10;
  total_page;
  page_number;
  // current_page = '1';
  featured;
  searched_item: any = "";
  closureValue;
  gmValue;
  cmValue;
  designerValue;
  errorMessage: string;
  successMessage: string;
  msgError: boolean = false;
  successError: boolean = false;

  item_delayed;
  item_start_date;
  item_end_date;
  item_date_column;
  send_file;
  sorting_col;
  sorting_ord;
  selectedGmItems = [];
  current_user_id;
  gm_dropdownSettings = {
    singleSelection: false,
    text: "General Managers",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    enableSearchFilter: true,
    classes: "myclass custom-class-dropdown",
  };
  cm_dropdownSettings = {
    singleSelection: false,
    text: "Community Managers",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    enableSearchFilter: true,
    classes: "myclass custom-class-dropdown",
  };
  designer_dropdownSettings = {
    singleSelection: false,
    text: "Designers",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    enableSearchFilter: true,
    classes: "myclass custom-class-dropdown",
  };
  gm_dropdownList = [];
  cm_dropdownList = [];
  designer_dropdownList = [];
  role: string;
  from_date;
  to_date;
  date_type;
  dash_filter;
  dashboardMsg;
  dash_filter_Message;
  forty_prod_value;
  selectedTab = "forty_to_hundred";
  activeTab = "40-100%";
  forty_collec_value;
  projectForty;
  scheduled;
  createClassificationForm: FormGroup;
  createClassificationactualForm: FormGroup;
  createClassificationsForm: FormGroup;
  createClassificationsactualForm: FormGroup;
  @Output() messagefortyEvent = new EventEmitter<number>();
  @Output() abcfortyevent = new EventEmitter<{ name1: number, name2: number }>();
  constructor(
    private formBuilder: FormBuilder,
    private leadService: LeadService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private router: Router

  ) {
     
  }

  ngOnInit() {
    this.createClassificationForm = this.formBuilder.group({
      date_detail: new FormControl(""),
      select_value: new FormControl(""),
      note_detail: new FormControl("", [Validators.required]),
    });
    this.createClassificationactualForm = this.formBuilder.group({
      date_detail: new FormControl(""),
      note_detail: new FormControl("", [Validators.required]),
    });
    this.createClassificationsForm = this.formBuilder.group({
      date_details: new FormControl(""),
      select_values: new FormControl("", [Validators.required]),
      note_details: new FormControl("", [Validators.required]),
    });
    this.createClassificationsactualForm = this.formBuilder.group({
      date_details: new FormControl(""),
      note_details: new FormControl("", [Validators.required]),
    });
    this.current_page = 1;
    this.current_user_id = localStorage.getItem('userId');
    this.role = localStorage.getItem('user');
    if (this.role === ('business_head')) {
      this.getGMList();
    }
    if (this.role === "city_gm") {
      this.getCMList(this.current_user_id);
    }
    if (this.role === "community_manager") {
      this.getDesignerList(this.current_user_id);
    }
    this.route.queryParams.subscribe((params) => {
      this.dash_filter = params["dashboard_filter"];
    });
    this.getColumnFilterValues();
    this.getValidReason();
    this.getItems(1, '', '', 1, 1, 1, '', '', '', '', '', '', '');
  }

  reason_list;
  getValidReason() {
    this.leadService.getValidReason().subscribe(res => {
      this.reason_list = res.data;
    });
  }

  activateTab(tab) {
    this.selectedTab = tab;
    switch (tab) {
      case "zero_to_forty":
        this.activeTab = "0-50%";
        break;
      case "forty_to_hundred":
        this.activeTab = "40-100%";
        break;
    }
  }
  
  getItems(pageno: any, searched: any, featured, gM, cM, dEsigner, delayed, datestart, dateend, date_column, file_data, sort_column, sort_order, date_type?, dashboard?, scheduled?) {
    if (file_data === undefined || file_data === '') {
      this.send_file = false;
    } else if (file_data !== undefined) {
      this.send_file = true;
    } else if (this.send_file === undefined) {
      this.send_file = false;
    }
    if (sort_column === undefined || sort_column === "") {
      this.sorting_col = "";
    } else if (this.sorting_col === undefined) {
      this.sorting_col = "";
    } else if (sort_column !== "") {
      this.sorting_col = sort_column;
    }
    // if (this.sorting_col !== '' && this.sorting_col !== undefined && sort_column === '') {
    //   this.sorting_col = this.sorting_col;
    // }

    if (sort_order === undefined || sort_order === "") {
      this.sorting_ord = "";
    } else if (this.sorting_ord === undefined) {
      this.sorting_ord = "";
    } else if (sort_order !== "") {
      this.sorting_ord = sort_order;
    }
    if (featured === undefined) {
      featured = this.featured;
    }
    if (featured === 1) {
      featured = this.featured;
    }
    if (gM === 1) {
      this.gmValue = "";
    } else if (this.gmValue !== "") {
      this.gmValue = this.gmValue;
    } else this.gmValue = gM;
    if (cM === 1) {
      this.cmValue = "";
    } else if (this.cmValue !== "") {
      this.cmValue = this.cmValue;
    } else this.cmValue = cM;
    if (dEsigner === 1) {
      this.designerValue = "";
    } else if (this.designerValue !== "") {
      this.designerValue = this.designerValue;
    } else this.designerValue = dEsigner;

    if (delayed === 1) {
      this.item_delayed = "";
    }
    if (datestart === 1) {
      this.item_start_date = "";
    }
    if (dateend === 1) {
      this.item_end_date = "";
    }
    if (date_column === 1) {
      this.item_date_column = "";
    }
    if (
      this.item_delayed !== "" &&
      this.item_delayed !== undefined &&
      delayed !== 1 &&
      delayed === ""
    ) {
      this.item_delayed = this.item_delayed;
    }

    if (
      this.item_delayed !== "" &&
      this.item_delayed !== undefined &&
      delayed !== 1 &&
      delayed !== ""
    ) {
      this.item_delayed = delayed;
    } else if (this.item_delayed === "" && delayed !== 1) {
      this.item_delayed = delayed;
    } else if (this.item_delayed === undefined) {
      this.item_delayed = delayed;
    }
    // this.item_delayed = delayed;
    if (
      this.item_start_date !== "" &&
      this.item_start_date !== undefined &&
      datestart !== 1 &&
      datestart === ""
    ) {
      this.item_start_date = this.item_start_date;
    }
    if (
      this.item_start_date !== "" &&
      this.item_start_date !== undefined &&
      datestart !== 1 &&
      datestart !== ""
    ) {
      this.item_start_date = datestart;
    } else if (this.item_start_date === "" && datestart !== 1) {
      this.item_start_date = datestart;
    } else if (this.item_start_date === undefined) {
      this.item_start_date = datestart;
    }
    // this.item_start_date = datestart;
    if (
      this.item_end_date !== "" &&
      this.item_end_date !== undefined &&
      dateend !== 1 &&
      dateend === ""
    ) {
      this.item_end_date = this.item_end_date;
    }
    if (this.item_end_date !== '' && this.item_end_date !== undefined && dateend !== 1 && dateend !== '') {
      this.item_end_date = dateend;
    }
    // this.item_end_date = dateend;
    if (this.item_date_column !== '' && this.item_date_column !== undefined && date_column !== 1 && date_column === '') {
      this.item_date_column = this.item_date_column;
    }
    if (this.item_date_column !== '' && this.item_date_column !== undefined && date_column !== 1 && date_column !== '') {
      this.item_date_column = date_column;
    }
    // this.item_date_column = date_column;

    // this.searched_item = searched;
    if (searched === 1) {
      this.searched_item = "";
    }
    if (
      this.searched_item !== "" &&
      this.searched_item !== undefined &&
      searched === 1
    ) {
      this.searched_item = "";
    }

    if (
      this.searched_item !== "" &&
      this.searched_item !== undefined &&
      searched === ""
    ) {
      this.searched_item = this.searched_item;
    }
    if (
      this.searched_item !== "" &&
      this.searched_item !== undefined &&
      searched !== "" &&
      searched !== 1
    ) {
      this.searched_item = searched;
    }
    if (
      this.searched_item === "" &&
      this.searched_item !== undefined &&
      searched !== "" &&
      searched !== 1
    ) {
      this.searched_item = searched;
    } else if (this.searched_item === undefined) {
      this.searched_item = searched;
    }
    if (
      this.date_type !== "" &&
      this.date_type !== undefined &&
      date_type === undefined
    ) {
      this.date_type = this.date_type;
    }
    // this.date_type = date_type;
    if (this.date_type === '' && date_type !== undefined && date_type !== 1) {
      this.date_type = date_type;
    }
    if (this.date_type !== '' && date_type !== undefined && date_type !== '' && date_type !== 1) {
      this.date_type = date_type;
    }
    if (this.date_type === undefined) {
      this.date_type = "actual";
    }
    // this.dash_filter = dashboard;
    if (
      this.dash_filter !== "" &&
      this.dash_filter !== undefined &&
      dashboard === undefined
    ) {
      this.dash_filter = this.dash_filter;
    }
    if (this.dash_filter === '' && dashboard !== undefined && dashboard !== 1) {
      this.dash_filter = dashboard;
    }
    if (this.dash_filter !== '' && dashboard !== undefined && dashboard !== '' && dashboard !== 1) {
      this.dash_filter = dashboard;
    }
    if (this.dash_filter === undefined) {
      this.dash_filter = "";
    }
    if (dashboard === 1) {
      this.dash_filter = "";
    }
    if (scheduled === true) {
      this.scheduled = true;
    }
    if (scheduled !== true) {
      this.scheduled = "";
    }
    this.current_page = pageno;
    this.featured = featured;
    this.per_page = 10;
    this.loaderService.display(true);
    this.leadService.getListwithTypeforty(this.allowed_items, this.current_page, 10, this.searched_item, this.featured, this.gmValue, this.cmValue, this.designerValue, this.item_delayed, this.item_start_date, this.item_end_date, this.item_date_column, this.send_file, this.sorting_col, this.sorting_ord, this.date_type, this.dash_filter, this.scheduled).subscribe(res => {
      
      if (res.success === true) {
        this.successError = true;
        if (res.message == "You will receive the report in email once it is ready.") {
          this.successMessage = res.message;
          setTimeout(function () {
            this.successError = false;
          }.bind(this), 6000);
          this.loaderService.display(false);
        }
        else {
          this.successMessage = "The report you requested is being created. It will be emailed to you once completed.!";
          setTimeout(function () {
            this.successError = false;
          }.bind(this), 6000);
          this.loaderService.display(false);
        }
      }
      else {
        this.items = res.lead_noc_data;
        if (this.items.length === 0) {
          this.msgError = true;
          this.errorMessage = "No Lead Data Found";
          setTimeout(function () {
            this.msgError = false;
          }.bind(this), 7000);
          this.current_page = res.current_page;
          this.total_page = res.zero_to_40_count;
          this.per_page = 10;
          this.projectForty = res.post_40_count;
          this.closureValue = res.closure_collected_amount;
          this.forty_prod_value = res.production_quotation_value;
          this.forty_collec_value = res.production_quotation_collection;
          // this.projectEvent.emit(this.total_page);
          // this.messagefortyEvent.emit(res.post_40_count);
          // this.abcfortyevent.emit({ name1: this.closureValue, name2: res.production_quotation_collection });
          // this.cdeevent.emit({ name1:this.closureValue, name2:res.production_quotation_collection });
          this.loaderService.display(false);
        }
        else {
          if (this.dash_filter !== '' && this.dash_filter !== undefined) {
            this.dashboardMsg = true;
            if (this.dash_filter === 'sent_to_production_date_expected_delayed') {
              this.dash_filter_Message = "Showing leads Where Sent To Production Date is Delayed";
            }
            if (this.dash_filter === 'service_start_date_expected_delayed') {
              this.dash_filter_Message = "Showing leads Where Service Start Date is Delayed";
            }
            if (this.dash_filter === 'service_per_50_date_expected_delayed') {
              this.dash_filter_Message = "Showing leads Where Service 50% Date is Delayed";
            }
            if (this.dash_filter === 'service_per_100_date_expected_delayed') {
              this.dash_filter_Message = "Showing leads Where Site Readiness Date is Delayed";
            }
            if (this.dash_filter === 'project_handover_date_expected_delayed') {
              this.dash_filter_Message = "Showing leads Where Project Handover Date is Delayed";
            }
          }
            this.msgError = false;
            this.current_page = res.current_page;
            this.total_page = res.zero_to_40_count;
            this.per_page = 10;
            this.projectForty = res.post_40_count;
            this.closureValue = res.closure_collected_amount;
            this.forty_prod_value = res.production_quotation_value;
            this.forty_collec_value = res.production_quotation_collection;
            // this.messagefortyEvent.emit(res.post_40_count);
            // this.abcfortyevent.emit({ name1:this.closureValue, name2:res.production_quotation_collection })
            this.loaderService.display(false);
          }
        
      }
      });
  }

  toggle_value;
  toggle_button(event) {
    this.toggle_value = event.target.checked;
    this.getItems(
      1,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      this.toggle_value
    );
  }

  removedashboard() {
    this.router.navigate([], {
      queryParams: {
        'dashboard_filter': null,
      },
      queryParamsHandling: 'merge'
    })
    this.getItems(1, '', '', 1, 1, 1, '', '', '', '', '', '', '', '', 1);
  }

  fortyData: any;
  fortypayments(data: any) {
    // this.fortyData = data;
  }

  searched_value: any;
  searchFilter(term: any) {
    this.searched_value = term.target.value;
    if (this.searched_value !== '') {
      this.getItems(1, this.searched_value, this.featured, 1, 1, 1, '', '', '', '', '', '', '');
    }
    else if (this.searched_value === '') {
      this.getItems(1, 1, this.featured, 1, 1, 1, '', '', '', '', '', '', '');
    }
  }

  getGMList() {
    this.leadService.getGMList(this.current_user_id).subscribe((res) => {
      this.gm_dropdownList = res.gms_list;
      this.gm_dropdownList = this.gm_dropdownList.map((item) => {
        return {
          id: item.id,
          itemName: item.item_name,
        };
      });
    });
  }

  gmlist;
  getCMList(id: any) {
    this.gmlist = id;
    this.leadService
      .getCMList(this.current_user_id, this.gmlist)
      .subscribe((res) => {
        this.cm_dropdownList = res.cms_list;
        this.cm_dropdownList = this.cm_dropdownList.map((item) => {
          return {
            id: item.id,
            itemName: item.item_name,
          };
        });
        // this.getItems(1,'',this.featured,this.gmlist)
      });
  }

  cmlist;
  getDesignerList(id: any) {
    this.cmlist = id;
    this.leadService
      .getDesignerListNOC(this.current_user_id, this.cmlist)
      .subscribe((res) => {
        this.designer_dropdownList = res.designers_list;
        this.designer_dropdownList = this.designer_dropdownList.map((item) => {
          return {
            id: item.id,
            itemName: item.item_name,
          };
        });
      });
  }

  date_values: any;
  getColumnFilterValues() {
    this.leadService.getColumnfilterdate().subscribe((res) => {
      this.date_values = res;
    });
  }

  cms;
  selectedCmItems = [];
  gms;
  designers;
  selectedDesignerItems = [];
  onItemSelect(items, textVal?, index?) {
    if (textVal == "cm" && index == 1) {
      this.cms = [];
      for (var k = 0; k < this.selectedCmItems.length; k++) {
        this.cms.push(this.selectedCmItems[k].id);
      }
      this.getDesignerList(this.cms);
      this.getItems(1, '', this.featured, '', this.cms, '', '', '', '', '', '', '', '')
    }
    else if (textVal == 'designer' && index == 2) {
      this.designers = [];
      for (var k = 0; k < this.selectedDesignerItems.length; k++) {
        this.designers.push(this.selectedDesignerItems[k].id);
      }
      this.getItems(1, '', this.featured, '', '', this.designers, '', '', '', '', '', '', '')

    }
    if (textVal == 'gm' && index == 3) {
      this.gms = [];
      for (var k = 0; k < this.selectedGmItems.length; k++) {
        this.gms.push(this.selectedGmItems[k].id);
      }
      this.getCMList(this.gms);
      this.getItems(1, '', this.featured, this.gms, '', '', '', '', '', '', '', '', '')
    }
  }
  OnItemDeSelect(items, textVal?, index?) {
    if (textVal == "gm" && index == 3) {
      for (var k = 0; k < this.gms.length; k++) {
        if (items.id == this.gms[k]) {
          this.gms.splice(k, 1);
        }
      }
    }
  }

  ClearGmFilter() {
    this.selectedGmItems = [];
    this.gms = [];
    this.getItems(1, '', this.featured, 1, '', '', '', '', '', '', '', '', '');
  }

  ClearCmFilter() {
    this.selectedCmItems = [];
    this.cms = [];
    this.getItems(1, '', this.featured, '', 1, '', '', '', '', '', '', '', '');
  }
  CleardesignerFilter() {
    this.selectedDesignerItems = [];
    this.designers = [];
    this.getItems(1, '', this.featured, '', '', 1, '', '', '', '', '', '', '');
  }

  ClearAreaFilter() {
    this.featured = false;
    this.getItems(1, '', this.featured, '', '', '', '', '', '', '', '', '', '');
  }

  value: any;
  getfeatured(data: any) {
    this.value = data;
    this.getItems(this.current_page, '', this.value, '', '', '', '', '', '', '', '', '', '');
  }
  downloadLeadData() {
    this.getItems(1, '', '', '', '', '', '', '', '', '', true, '', '');
  }

  sort1: any;
  sort2: any;
  orderChange(id: any, id2: any) {
    this.getItems(1, '', '', '', '', '', '', '', '', '', '', id, id2);
  }
  delayed_data: any = 1;
  redflagclick(delayed) {
    this.delayed_data = delayed;
    this.getItems(1, '', '', '', '', '', delayed, '', '', '', '', '', '');
  }
  ClearFlagFilter() {
    this.delayed_data = 1;
    this.getItems(1, '', '', '', '', '', 1, '', '', '', '', '', '');
  }

  obj_list: any;
  featureddata(lead_id: any) {
    this.obj_list = {
      lead_id: lead_id,
      type: this.allowed_items,
    };
    this.leadService.addToFeatured(this.obj_list).subscribe((res) => {
      alert("Lead Added to featured");
      $(window).scrollTop(0);
      setTimeout(function () {
      }.bind(this), 2000);
      this.getItems(this.current_page, '', 'true', 1, 1, 1, '', '', '', '', '', '', '');
    })
  }

  removefeatureddata(lead_id: any) {
    this.obj_list = {
      lead_id: lead_id,
      type: this.allowed_items,
    };
    this.leadService.removefromFeatured(this.obj_list).subscribe((res) => {
      alert("Lead Removed From Featured");
      $(window).scrollTop(0);
      setTimeout(function () {
      }.bind(this), 2000);
      this.getItems(this.current_page, '', 'false', 1, 1, 1, '', '', '', '', '', '', '');
    })
  }

  date_dropdown;
  dateDropDownChanged(event: any) {
    this.date_dropdown = event;
  }

  ClearDateFilter() {
    this.item_start_date = "";
    this.item_end_date = "";
    this.item_date_column = "";
    this.from_date = "";
    this.to_date = "";
    this.date_dropdown = "";
    this.getItems(1, '', '', '', '', '', '', 1, 1, 1, '', '', '');
  }
  final_from_date;
  final_to_date;
  submitByDate() {
    if (this.from_date !== null) {
      var todayTime = this.from_date;
      var month = parseInt(("0" + (todayTime.getMonth() + 1)).slice(-2));
      var day = todayTime.getDate();
      var year = todayTime.getFullYear();
      this.final_from_date = day + "-" + month + "-" + year;
    }
    if (this.to_date !== null) {
      var todayTime = this.to_date;
      var month = parseInt(("0" + (todayTime.getMonth() + 1)).slice(-2));
      var day = todayTime.getDate();
      var year = todayTime.getFullYear();
      this.final_to_date = day + "-" + month + "-" + year;
    }
    this.getItems(1, '', '', '', '', '', '', this.final_from_date, this.final_to_date, this.date_dropdown, '', '', '');;
  }

  onSelectAll(items) { }
  onDeSelectAll(items) { }

  date_type_filter;
  changeDateType(value) {
    this.date_type_filter = value;
    this.getItems(1, "", "", "", "", "", "", "", "", "", "", "", "", value);
  }

  cascading_items;
  cascading_items_nonboq;
  showDetails: boolean = true;
  showDetails_non_service: boolean = true;
  getBOQdetails(leadId: any, index: any) {
    this.cascading_items = [];
    this.leadService.getBoqDetailforty(leadId).subscribe((response) => {
      this.cascading_items = response.quotations;
      if (response.quotations.length === 0) {
        this.showDetails = false;

        $(".location").hide();
      } else {
        this.showDetails = true;
      }
    });
    this.cascading_items_nonboq = [];
    this.leadService
      .getBoqDetailfortynonservice(leadId)
      .subscribe((response) => {
        this.cascading_items_nonboq = response.quotations;
        if (response.quotations.length === 0) {
          this.showDetails_non_service = false;
          // alert("No BOQ Data Present");
          $(".location_nonservice").hide();
        } else {
          this.showDetails_non_service = true;
        }
      });
    if (this.showDetails === false && this.showDetails_non_service === false) {
      alert("No BOQ Data Present");
    }
  }

  toggleRow(data, i) {
    data.expanded = !data.expanded;
    $(".location").hide();
    $("#Location" + i).show();
    data.boq_expanded = !data.boq_expanded;
    $(".location_nonservice").hide();
    $("#Location_boq" + i).show();
  }

  fortyquoteData: any;
  fortyquotepayment(data: any) {
    // this.fortyquoteData = data;
  }

  lead;
  ownrable_id;
  date_name;
  current_date;
  changeexpexteddate(event1) {
    $("#expectedDateModal").modal("show");
    this.lead = event1;
    this.date_name = this.lead_display;
    this.current_date = this.lead_expect_date;
  }

  current_actual_date;
  changeactualdate(event1) {
    $("#expectedDateActualModal").modal("show");
    this.lead = event1;
    this.date_name = this.lead_display;
    this.current_actual_date = this.lead_actual_date;
  }

  dateDetails(data) {
    this.loaderService.display(true);
    this.leadService.changeLeadDate(this.lead, this.ownrable_id, this.lead_display_date, data.date_detail, data.select_value, data.note_detail).subscribe(res => {
      $('#expectedDateModal').modal('hide');
      $('#fmailModal').modal('hide');
      this.loaderService.display(false);
      this.successError = true;
      this.createClassificationForm.reset();
      this.successMessage = "Date has been Updated";
      setTimeout(function () {
        this.successError = false;
      }.bind(this), 3000);
      this.getItems(this.current_page, '', '', '', '', '', '', '', '', '', '', '', '');
    })
  }

  dateDetailsactal(data) {
    this.loaderService.display(true);
    this.leadService.changeLeadActualDate(this.lead, this.ownrable_id, this.lead_display_date, data.date_detail, data.note_detail).subscribe(res => {
      $('#expectedDateActualModal').modal('hide');
      $('#fmailModal').modal('hide');
      this.loaderService.display(false);
      this.successError = true;
      this.createClassificationactualForm.reset();
      this.successMessage = "Date has been Updated";
      setTimeout(function () {
        this.successError = false;
      }.bind(this), 3000);
      this.show_actual_value = false;
      this.getItems(this.current_page, '', '', '', '', '', '', '', '', '', '', '', '');
    })
  }

  leads;
  ownrable_ids;
  date_names;
  current_dates;
  note_details;
  index;
  changeexpexteddateQuote(event1) {
    $("#expectedDatesModal").modal("show");
    this.leads = event1;
    // this.ownrable_ids = event2;
    this.date_names = this.boq_display;
    // this.index = event5;
    this.current_dates = this.boq_expect_date;
  }

  current_dates_boq;
  changeactualdateBOQ(event1) {
    $("#expectedDatesActualModal").modal("show");
    this.leads = event1;
    this.date_names = this.boq_display;
    this.current_dates_boq = this.boq_actual_date;
  }

  dateDetailss(data) {
    this.loaderService.display(true);
    this.leadService.changeLeadDate(this.leads, this.ownrable_ids, this.boq_display_date, data.date_details, data.select_values, data.note_details).subscribe(res => {
      $('#expectedDatesModal').modal('hide');
      this.loaderService.display(false);
      this.successError = true;
      this.createClassificationsForm.reset();
      this.successMessage = "Date has been Updated";
      this.createClassificationsForm.reset();
      setTimeout(function () {
        this.successError = false;
      }.bind(this), 3000);
      this.getItems(this.current_page, '', '', '', '', '', '', '', '', '', '', '', '');
    })
  }

  dateDetailssactual(data) {
    this.loaderService.display(true);
    this.leadService
      .changeLeadActualDate(
        this.leads,
        this.ownrable_ids,
        this.boq_display_date,
        data.date_details,
        data.note_details
      )
      .subscribe((res) => {
        $("#expectedDatesActualModal").modal("hide");
        $("#fmailsModal").modal("hide");
        this.loaderService.display(false);
        this.successError = true;
        this.createClassificationsactualForm.reset();
        this.successMessage = "Date has been Updated";
        setTimeout(
          function () {
            this.successError = false;
          }.bind(this),
          3000
        );
        this.show_actual_value_boq = false;
        this.getItems(
          this.current_page,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          ""
        );
      });
  }

  closeonemodal() {
    $("#expectedDateModal").modal("hide");
    this.createClassificationForm.reset();
  }

  closetwomodal() {
    $("#expectedDatesModal").modal("hide");
    this.createClassificationsForm.reset();
  }

  note_detail;
  reason_dropdown;
  reasonDropDownChanged(event) {
    this.reason_dropdown = event;
  }

  reason_dropdowns;
  reasonDropDownsChanged(event) {
    this.reason_dropdowns = event;
  }

  first_data;
  second_data;
  getDelayedData() {
    $("#expectedDatesReasonModal").modal("show");
  }

  boq_data;
  boq_data2;
  getDelayedboqData(event1, event2) {
    this.boq_data = event1;
    this.boq_data2 = event2;
    $("#expectedDatesReasonBOQModal").modal("show");
  }

  lead_ideal_date;
  lead_expect_date;
  lead_actual_date;
  lead_display_date;
  lead_display;
  show_expect_value: boolean = false;
  show_actual_value: boolean = false;
  getNodeDetail(event, event2, event3) {
    this.show_actual_value = false;
    this.lead_ideal_date = event.ideal;
    this.lead_expect_date = event.expected;
    this.lead_actual_date = event.actual;
    this.lead_display_date = event2;
    this.lead_display = event2;
    if (this.lead_display === "Panel Production Start") {
      this.lead_display = "Panel Start";
    }
    if (this.lead_display === "Non Panel Dispatch") {
      this.lead_display = "Select Dispatch";
    }
    if (this.lead_display_date === "Non Panel Dispatch") {
      this.lead_display_date = "Select Dispatch";
    }
    if (event.expected && !event.actual) {
      this.show_expect_value = true;
    }
    this.first_data = event.reason;
    this.second_data = event.notes;
    this.ownrable_id = event3.lead_id;
    this.fortyData = event3.forty_per_payment.data;
    if ((event2 === ("Raw Material") || event2 === ("Panel Production Start") || event2 === ("Panel Dispatch") || event2 === ("Select Start") || event2 === ("Non Panel Dispatch") || event2 === ("LF Start") || event2 === ("Loose Furniture Dispatch")) && event3.timeline[event2].actual_manual_date === null && event3.timeline[event2].can_edit === true && this.role === 'category_head') {
      this.show_actual_value = true;
    }
    else if ((event2 === ("Raw Material") || event2 === ("Panel Production Start") || event2 === ("Panel Dispatch") || event2 === ("Select Start") || event2 === ("Non Panel Dispatch") || event2 === ("LF Start") || event2 === ("Loose Furniture Dispatch")) && event3.timeline[event2].actual_manual_date !== null && event3.timeline[event2].can_edit === true && this.role === 'category_head') {
      this.show_actual_value = false;
    }
    else if ((event2 === ("Raw Material") || event2 === ("Panel Production Start") || event2 === ("Panel Dispatch") || event2 === ("Select Start") || event2 === ("Non Panel Dispatch")) && event3.timeline[event2].actual_manual_date === null && event3.timeline[event2].can_edit === true && this.role === 'category_panel') {
      this.show_actual_value = true;
    }
    else if ((event2 === ("Raw Material") || event2 === ("Panel Production Start") || event2 === ("Panel Dispatch") || event2 === ("Select Start") || event2 === ("Non Panel Dispatch")) && event3.timeline[event2].actual_manual_date !== null && event3.timeline[event2].can_edit === true && this.role === 'category_panel') {
      this.show_actual_value = false;
    }
    else if ((event2 === ("LF Start") || event2 === ("Loose Furniture Dispatch")) && event3.timeline[event2].actual_manual_date === null && event3.timeline[event2].can_edit === true && this.role === 'category_non_panel') {
      this.show_actual_value = true;
    }
    else if ((event2 === ("LF Start") || event2 === ("Loose Furniture Dispatch")) && event3.timeline[event2].actual_manual_date !== null && event3.timeline[event2].can_edit === true && this.role === 'category_non_panel') {
      this.show_actual_value = false;
    }
    $('#fmailModal').modal('show');
  }

  closefmail() {
    $('#fmailModal').modal('hide');
    this.show_expect_value = false;
  }

  boq_ideal_date;
  boq_expect_date;
  boq_actual_date;
  boq_display_date;
  boq_display;
  boq_detail_obj;
  show_expect_value_boq: boolean = false;
  show_actual_value_boq: boolean = false;

  getNodeDetailBOQ(event, event2, event3, event4) {
    this.show_expect_value_boq = false;
    this.show_actual_value_boq = false;
    this.boq_ideal_date = event.ideal;
    this.boq_expect_date = event.expected;
    this.boq_actual_date = event.actual;
    this.boq_display_date = event2;
    this.boq_display = event2;
    if (this.boq_display_date === "Non Panel Dispatch") {
      this.boq_display_date = "Select Dispatch";
    }
    if (this.boq_display === "Panel Production Start") {
      this.boq_display = "Panel Start";
    }
    if (this.boq_display === "Non Panel Dispatch") {
      this.boq_display = "Select Dispatch";
    }
    if (event.expected && !event.actual) {
      this.show_expect_value_boq = true;
    }
    this.boq_data = event.reason;
    this.boq_data2 = event.notes;
    this.boq_detail_obj = event3;
    this.ownrable_ids = event3.id;
    this.index = event4;
    this.fortyquoteData = event3.quotation_data.per_40_payment_mapped_date;
    if ((event2 === ("Raw Material") || event2 === ("Panel Production Start") || event2 === ("Panel Dispatch") || event2 === ("Select Start") || event2 === ("Non Panel Dispatch") || event2 === ("LF Start") || event2 === ("Loose Furniture Dispatch")) && event3.quotation_data.timeline[event2].actual_manual_date === null && event3.quotation_data.timeline[event2].can_edit === true && this.role === 'category_head') {
      this.show_actual_value_boq = true;
    }
    else if ((event2 === ("Raw Material") || event2 === ("Panel Production Start") || event2 === ("Panel Dispatch") || event2 === ("Select Start") || event2 === ("Non Panel Dispatch") || event2 === ("LF Start") || event2 === ("Loose Furniture Dispatch")) && event3.quotation_data.timeline[event2].actual_manual_date !== null && event3.quotation_data.timeline[event2].can_edit === true && this.role === 'category_head') {
      this.show_actual_value_boq = false;
    }

    else if ((event2 === ("Raw Material") || event2 === ("Panel Production Start") || event2 === ("Panel Dispatch") || event2 === ("Select Start") || event2 === ("Non Panel Dispatch")) && event3.quotation_data.timeline[event2].actual_manual_date === null && event3.quotation_data.timeline[event2].can_edit === true && this.role === 'category_panel') {
      this.show_actual_value_boq = true;
    }
    else if ((event2 === ("Raw Material") || event2 === ("Panel Production Start") || event2 === ("Panel Dispatch") || event2 === ("Select Start") || event2 === ("Non Panel Dispatch")) && event3.quotation_data.timeline[event2].actual_manual_date !== null && event3.quotation_data.timeline[event2].can_edit === true && this.role === 'category_panel') {
      this.show_actual_value_boq = false;
    }
    else if ((event2 === ("LF Start") || event2 === ("Loose Furniture Dispatch")) && event3.quotation_data.timeline[event2].actual_manual_date === null && event3.quotation_data.timeline[event2].can_edit === true && this.role === 'category_non_panel') {
      this.show_actual_value_boq = true;
    } else if (
      (event2 === "LF Start" || event2 === "Loose Furniture Dispatch") &&
      event3.quotation_data.timeline[event2].actual_manual_date !== null &&
      event3.quotation_data.timeline[event2].can_edit === true &&
      this.role === "category_non_panel"
    ) {
      this.show_actual_value_boq = false;
    }
    $("#fmailsModal").modal("show");
  }

  closefamils() {
    $("#fmailsModal").modal("hide");
    this.show_expect_value_boq = false;
  }

  openpopup(event) {
    var thisobj = this;
    $(event.target).popover({
      trigger: 'hover'
    });

    //$(this).popover();
    $(function () {
      $('.pop').popover({
        trigger: 'hover'
      })
    })
  }

  runJob(event) {
    this.loaderService.display(true);
    this.leadService.runJob(event).subscribe((res) => {
      this.loaderService.display(false);
      this.successError = true;
      this.successMessage = "Job ran Successfully";
      setTimeout(
        function () {
          this.successError = false;
        }.bind(this),
        3000
      );
      this.getItems(
        this.current_page,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
      );
    });
  }

  setTodayDate() {
    this.from_date = new Date();
    this.to_date = new Date();
  }
  private _trasformDateType(dateValue) {
    return moment(dateValue).format('DD-MM-yyyy')
  }
}


// WEBPACK FOOTER //
// ./src/app/platform/organisation/forty-to-hundred/forty-to-hundred.component.ts